import axios from 'axios';
import REACT_APP_BACK_URL from '../../constants/constants';

export const sendMailForCreation = async (
  { email },
) => axios
  .post(
    `${REACT_APP_BACK_URL}/sendMailForCreation`,
    { email },
  );

export const checkMailAndCode = async (
  { email, code },
) => axios
  .post(
    `${REACT_APP_BACK_URL}/checkMailAndCode`,
    { email, code },
  );

export const createEmailAccount = async (
  { password, passwordToken },
) => {
  const inviteToken = sessionStorage.getItem('inviteToken') || undefined;
  return axios.post(
    `${REACT_APP_BACK_URL}/createEmailAccount`,
    { password, passwordToken, inviteToken },
  );
};

export const loginWithEmailPassword = async (
  { email, password },
) => {
  const inviteToken = sessionStorage.getItem('inviteToken') || undefined;
  return axios.post(
    `${REACT_APP_BACK_URL}/loginWithEmailPassword`,
    { email, password, inviteToken },
  );
};

export const logout = async () => axios
  .get(
    `${REACT_APP_BACK_URL}/logout`,
  );

export const checkPseudo = async (
  { pseudo },
) => axios
  .post(
    `${REACT_APP_BACK_URL}/checkPseudo`,
    { pseudo },
  );
